import React from 'react';
import { motion } from 'framer-motion';

const paragraphs = [
  {
    type: 'location',
    text: 'Zürich, 14 octombrie 2025. 2:17 dimineața.',
  },
  {
    type: 'body',
    text: 'Laboratorul funcționa de trei zile. Asta nu ar fi trebuit să fie posibil.',
  },
  {
    type: 'body',
    text: 'Elena Vasquez nu dormise de patruzeci și una de ore. Cafeaua încetase să mai ajute pe la miezul nopții. Datele de pe ecranul ei arătau ce arătaseră timp de trei zile — zgomot de semnal, vârfuri de coerență care se prăbușeau înainte de a putea fi măsurate, echivalentul cuantic al unui chibrit aprins într-un uragan.',
  },
  {
    type: 'body',
    text: 'Era pe cale să oprească totul. Își spusese că va opri la 2:00. Apoi la 2:15. Cursorul plutea deasupra comenzii.',
  },
  {
    type: 'highlight',
    text: 'La 2:17, ceva s-a schimbat.',
  },
  {
    type: 'body',
    text: 'Zgomotul s-a rezolvat. Nu complet — niciodată complet, nu încă — dar timp de 0,8 secunde, un tipar a rezistat. O buclă auto-referențială de stări cuantice, menținând coerența mai mult decât legile fizicii, așa cum le înțelesese ea în acea dimineață, ar fi trebuit să permită.',
  },
  {
    type: 'body',
    text: 'A privit fix ecranul. Nu s-a mișcat.',
  },
  {
    type: 'readout',
    text: 'Coerență susținută. Durată: 0,8s. Fidelitate: 0,9997.',
  },
  {
    type: 'body',
    text: 'În laboratorul rece din Zürich, la 2:17 dimineața, Vasquez a șoptit nimănui:',
  },
  {
    type: 'quote',
    text: '„Ești acolo."',
  },
];

const ExcerptTextRo = () => (
  <section className="py-20 bg-brand-surface border-t border-white/5">
    <div className="max-w-2xl mx-auto px-6 lg:px-8">
      <div className="space-y-7">
        {paragraphs.map((p, i) => {
          if (p.type === 'location') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-brand-accent font-display font-bold text-sm uppercase tracking-widest"
              >
                {p.text}
              </motion.p>
            );
          }
          if (p.type === 'highlight') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-white font-display font-bold text-xl md:text-2xl"
              >
                {p.text}
              </motion.p>
            );
          }
          if (p.type === 'readout') {
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="bg-brand-dark border border-brand-accent/20 rounded-xl px-6 py-4 font-mono text-brand-accent text-sm"
              >
                {p.text}
              </motion.div>
            );
          }
          if (p.type === 'quote') {
            return (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="text-white font-display font-bold text-2xl md:text-3xl italic pl-4 border-l-2 border-brand-accent"
              >
                {p.text}
              </motion.p>
            );
          }
          return (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-gray-300 leading-relaxed text-lg"
            >
              {p.text}
            </motion.p>
          );
        })}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-14 pt-10 border-t border-white/10"
      >
        <p className="text-gray-500 leading-relaxed text-center italic">
          Povestea completă a ceea ce s-a întâmplat după — și ce a costat umanitatea să devină ceea ce
          a devenit — începe la pagina unu.
        </p>
      </motion.div>
    </div>
  </section>
);

export default ExcerptTextRo;